module.exports = function() {
  return new Worker(__webpack_public_path__ + "902332f554f38f7ec5b9.worker.js");
};